var html = require("choo/html");

module.exports = thanks;

function thanks(state, emit) {
  emit('meta', {
    title: 'Designstipendiet Ã¢ÂÂ Klart!',
    'og:image': 'https://www.designstipendiet.se/share-image.png',
    'og:url': 'https://www.designstipendiet.se/tack',
  })

  return html`
    <body>
      <main class="Thanks">
        <div class="Thanks-text">
          <h1 class="Thanks-title">Tack!</h1>
          <p>
            Vi kontaktar dig nÃÂ¤r urvalet till Designstipendiet ÃÂ¤r beslutat.
            Svaret kommer i bÃÂ¶rjan av juli, 2026.
          </p>
          <p>Fler ÃÂ¤n en person kan fÃÂ¥ stipendet, sÃÂ¥ tipsa gÃÂ¤rna en kompis.</p>
        </div>
      </main>
    </body>
  `;
}
